// extracted by mini-css-extract-plugin
export var copy = "postCard-module--copy--J3nii";
export var arrow = "postCard-module--arrow--N7z26";